"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MODAL_BUTTON_SELECT_PRIORITIES = void 0;
const MODAL_BUTTON_SELECT_PRIORITIES = exports.MODAL_BUTTON_SELECT_PRIORITIES = {
  cancel: 1,
  secondary: 2,
  primary: 3,
  x: 4
};
//# sourceMappingURL=ModalButtons.types.js.map